import React from 'react';
import classNames from 'classnames';


/**
 * React component for creating our anvil specific button.
 *
 * @param {string} text - The words the button should have.
 * @param {string} className - Additional classes as a string to add to the button element.
 * @param {bool} fill - Whether or not the button should fill the container it is in.
 * @param {bool} showLoader - Whether or not the loader for the button should be shown.
 * @param {bool} successColor - Whether or not this button should be colored using the success color.
 * @param {object} buttonAttrs - Any additional attributes to add to the button.
 * @returns {*}
 * @constructor
 */
export function Button({text, className='', fill=false, showLoader=false, successColor=false, ...buttonAttrs}) {
    const buttonClasses = classNames('anvil-button', className, {'anvil-button--fill': fill}, {'anvil-button--success': successColor});
    const loaderClasses = classNames('anvil-loader', 'anvil-loader--small', {'anvil-loader--visible': showLoader});
    if (buttonAttrs == null) {
        buttonAttrs = {};
    }

    return (
        <button className={buttonClasses} {...buttonAttrs}>
            <span className="anvil-button__text">{text}</span>
            <span className={loaderClasses}></span>
        </button>
    );
}
